import { useMemo } from 'react';
import TimelineGroups from './timeline';

/* Strip any HTML tags so activity comments render as clean plain text. */
function toPlainText(html = '') {
  if (typeof document === 'undefined') return String(html);
  const holder = document.createElement('div');
  holder.innerHTML = html;
  return holder.textContent || holder.innerText || '';
}

const sampleActivity = [
  {
    id: 'a1',
    activityTime: new Date().toISOString(),
    activityComments: 'Job <b>created</b> and assigned to the recruitment team.',
  },
  {
    id: 'a2',
    activityTime: new Date(Date.now() - 2 * 86400000).toISOString(),
    activityComments: 'Status changed to <b>Active</b>.',
  },
];

export default function ActivityTab({ activity }) {
  const rows = useMemo(
    () => (Array.isArray(activity) ? activity : sampleActivity),
    [activity],
  );

  return (
    <div className="znx-an-body">
      <div className="znx-an-scroll">
        <TimelineGroups
          rows={rows}
          getTime={(row) => row.activityTime ?? row.createdAt}
          getKey={(row, index) => row.id ?? row._id ?? index}
          emptyText="No activity here."
          renderBody={(row) => (
            <div className="znx-an-comment">{toPlainText(row.activityComments)}</div>
          )}
        />
      </div>
    </div>
  );
}
